import {Body} from '../typography/body';
import type {Color, TextSize} from '../typography/body';

import styles from './divider.module.css';

interface Props {
    text?: string;
    color?: Color;
    size?: TextSize;
    isBold?: boolean;
    isDisabled?: boolean;
}

export function Line(props: Props) {
    return (
        <div className={props.isDisabled ? styles['container--disabled'] : styles.container}>
            <div className={styles['divider-line']} />
            {props.text && (
                <div className={styles['divider-text']}>
                    <Body color={props.color} size={props.size} isBold={props.isBold}>
                        {props.text}
                    </Body>
                </div>
            )}
            <div className={styles['divider-line']} />
        </div>
    );
}
